import { render, staticRenderFns } from "./petunjukPostTest.vue?vue&type=template&id=7af658e6"
import script from "./petunjukPostTest.vue?vue&type=script&lang=js"
export * from "./petunjukPostTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports